import { Component } from '@angular/core';

@Component({
  selector: 'app-compliance-rules',
  templateUrl: './compliance-rules.component.html',
  styleUrls: ['./compliance-rules.component.scss']
})
export class ComplianceRulesComponent {
  complianceRuleEnabled = true;
  compliancePriority = 'Medium';
  notCompliantEnabled = false;
  notCompliantDay = 30;
  notCompliantPriority = 'Medium';
  showNotCompliantRule = false;
  showNotCompliantRulesText = false;
  ruleConfigs = [
    {
      complianceRuleEnabled: true,
      compliancePriority: 'Medium',
      notCompliantEnabled: false,
      notCompliantDay: 30,
      notCompliantPriority: 'Medium',
    }
  ];

  addNotCompliantRule() {
    this.showNotCompliantRule = true;
    this.showNotCompliantRulesText = true;
    this.ruleConfigs[0].notCompliantEnabled = true;
  }

  hideNotCompliantRule() {
    this.showNotCompliantRule = false;
    this.showNotCompliantRulesText = false;
    this.ruleConfigs[0].notCompliantEnabled = false;
  }

  editRule() {
    // Add logic to edit the compliance rule
    alert('Edit rule clicked');
  }

  copyRule() {
    // Add logic to copy the compliance rule
    alert('Copy rule clicked');
  }

  cancelNotCompliant() {
    // Reset not compliant section to previous state or defaults
    this.notCompliantEnabled = false;
    this.notCompliantDay = 30;
    this.notCompliantPriority = 'Medium';
  }

  saveNotCompliant() {
    // Save not compliant rule logic
    alert('Not compliant rule saved!');
  }

  removeNotCompliant() {
    // Remove not compliant rule logic
    this.notCompliantEnabled = false;
    alert('Not compliant rule removed!');
  }

  duplicateRuleConfig() {
    this.ruleConfigs.push({
      complianceRuleEnabled: true,
      compliancePriority: 'Medium',
      notCompliantEnabled: false,
      notCompliantDay: 30,
      notCompliantPriority: 'Medium',
    });
  }

  editRuleConfig(index: number) {
    alert('Edit rule configuration ' + (index + 1));
  }
}
